module.exports = __webpack_public_path__ + "resources/icon_44_applaud.1492d8046fd9f01c.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_applaud.png
// module id = 422
// module chunks = 0 1 2 3 4